/**
 * Configuration utilities for Get Talky Agent
 * Handles environment-specific URLs and settings
 */

/**
 * Get the browser backend service URL based on environment
 * @returns {string} The browser backend URL
 */
export const getBrowserBackendUrl = () => {
  // In production, we always use the explicit backend URL.
  // In local development, this can be overridden by a .env.local file.
  return process.env.REACT_APP_BROWSER_BACKEND_URL || 'https://browser-backend-dev-zyki23ongq-uc.a.run.app';
};

/**
 * Get Socket.IO configuration for the current environment
 * @returns {object} Socket.IO configuration options
 */
export const getSocketConfig = () => {
  const baseConfig = {
    forceNew: true,
    transports: ['websocket'],
  };

  // Local development
  if (process.env.NODE_ENV === 'development') {
    return {
      ...baseConfig,
      cors: {
        origin: 'http://localhost:3002',
        methods: ['GET', 'POST']
      }
    };
  }

  // Production - more permissive CORS
  return {
    ...baseConfig,
    cors: {
      origin: true,
      methods: ['GET', 'POST']
    }
  };
};

/**
 * Check if we're running in local development mode
 * @returns {boolean}
 */
export const isLocalDevelopment = () => {
  return process.env.NODE_ENV === 'development' || 
         process.env.REACT_APP_LOCAL_MODE === 'true';
};

/**
 * Get the current stage/environment
 * @returns {string}
 */
export const getCurrentStage = () => {
  return process.env.REACT_APP_STAGE || 
         process.env.STAGE || 
         'dev';
}; 